import { TSeller } from '../../types/agent';

export const isLeadFactory = (agent: TSeller): boolean => agent.isLeadFactory;
